import { render, staticRenderFns } from "./lectureManage.vue?vue&type=template&id=cb93762a&scoped=true&"
import script from "./lectureManage.vue?vue&type=script&lang=js&"
export * from "./lectureManage.vue?vue&type=script&lang=js&"
import style0 from "./lectureManage.vue?vue&type=style&index=0&id=cb93762a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb93762a",
  null
  
)

export default component.exports